// extracted by mini-css-extract-plugin
export default {"tags":"OutputBox_tags__q4GCL","tagItem":"OutputBox_tagItem__yZobL","active":"OutputBox_active__gFDRk"};